export default __webpack_public_path__ + "static/media/augs-aircraft.aeebe44a.jpg";